export interface Message {
  id: number;
  date: Date;
  chargePointName: string;
  centralSystemName: string;
  messageVersion: string;
  messageAction: string;
  messageType: MessageType;
  headers: string;
  payload: string;
  chargePointMessage: string;
}

export enum MessageType {
  REQUEST = 'REQUEST',
  RESPONSE = 'RESPONSE',
  ERROR = 'ERROR'
}
